export const hideHTMLElement = (element: HTMLElement, hide: boolean) => {
    element.classList.remove("show-fade-in", "hide-fade-out");
    element.classList.add(hide ? "hide-fade-out" : "show-fade-in");
}